import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding: ${size[24]};
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
  background-color: ${theme.palette.background.main};
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    min-height: ${width.container.standard};
    max-width: ${width.container.wider};
    margin: 0 auto;
    gap: ${size[48]};
  }
`

export const header = css`
  display: flex;
  flex-direction: column;
  gap: ${size[24]};

  ${breakpoint.up('smMd')} {
    text-align: center;
  }
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const description = css`
  margin: 0;
  font-size: ${fontSize.smMd};
  line-height: 1.2;
`

export const content = css`
  ${breakpoint.up('smMd')} {
    display: flex;
    justify-content: space-between;
  }
`

export const features = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};

  ${breakpoint.up('smMd')} {
    gap: ${size[48]};
    max-width: ${width.modal.compact};
  }
`

export const feature = (theme: Theme) => css`
  svg path {
    fill: ${theme.palette.secondary.mainContrast};
  }

  p {
    margin: ${size[12]} 0 0;
    color: ${theme.palette.tertiary.upperMediumContrast};
    font-size: ${fontSize.smMd};
  }
`

export const featureHeader = css`
  display: flex;
  align-items: center;
  gap: ${size[12]};

  span {
    font-size: ${fontSize.lg};
    font-weight: 600;
  }
`

export const formWrapper = css`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 532px;
`

export const form = (theme: Theme) => css`
  margin-top: ${size[24]};
  padding: ${size[24]} ${size[16]};
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  background-color: ${theme.palette.background.main};
  border: 1px solid ${theme.palette.tertiary.lowContrast};
  border-radius: ${size[12]};
  box-shadow: ${theme.shadows.box};
  text-align: center;

  button {
    margin-top: ${size[18]};
  }

  ${breakpoint.up('smMd')} {
    margin-top: 0;
    padding: ${size[32]};
    min-width: ${width.container.small};
  }
`

export const banner = (theme: Theme) => css`
  padding: ${size[24]} ${size[16]};
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
  background-color: ${theme.palette.primary.maxContrast};
  color: ${theme.palette.background.main};
  border-radius: ${theme.borderRadius.md};
  font-size: ${fontSize.smMd};
  font-weight: 500;

  button {
    width: 100%;
  }

  svg {
    align-self: flex-start;
  }

  ${breakpoint.up('smMd')} {
    padding: ${size[12]};
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: ${size[48]};

    button {
      width: fit-content;
    }

    svg {
      align-self: center;
    }
  }
`
